import React from 'react';
import { Link } from 'react-router-dom';
import BannerAssociation from '../BannerAssociation/BannerAssociation';
import QuiSommesNous from '../QuiSommesNous/QuiSommesNous';
import NosChiffresCles from '../NosChiffresCles/NosChiffresCles';
import Constats from '../Constats/Constats';
import NotreMission from '../NotreMission/NotreMission';
import NosServices from '../NosServices/NosServices';
import EtapesCles from '../EtapesCles/EtapesCles';
import './AccueilAssociation.css';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';

const AccueilAssociation = () => {
  return (
    <div className="accueil-association">
      <Header />
      <BannerAssociation />
      <QuiSommesNous />
      <NosChiffresCles />
      <Constats />
      <NotreMission />
      <NosServices />
      <EtapesCles />

      {/* Section CTA finale */}
      <section className="association-cta">
        <div className="cta-container">
          <div className="cta-content">
            <h2 className="cta-title">REJOIGNEZ-NOUS</h2>
            <div className="cta-line"></div>
            <p className="cta-descriptions">
              Nous vous invitons à rejoindre notre communauté d'étudiants étrangers. 
              Que vous soyez encore en Afrique ou déjà en France, vous trouverez des ressources, 
              des conseils et un soutien continus pour réussir votre parcours académique et professionnel.
            </p>
            <p className="cta-subdescription">
              Rejoignez-nous sur Facebook et notre plateforme pour faire partie de notre réseau 
              et bénéficier d'un accompagnement personnalisé !
            </p>
            <Link 
              to="https://www.facebook.com/groups/516146849131280"
              className="cta-button-join"
              target="_blank"
              rel="noopener noreferrer"
            >
              Intégrer la communauté
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AccueilAssociation;